import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const TituloFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TITULO' htmlFor='select-titulo' md={2} alignRightAt='md' />
      <Col md={10}>
        <Field name='titulo'>
          {({ field }) => <Form.InputText {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-titulo' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloFormGroup)
